export const MAX_TRANSACTION_SIZE = 102400;

//# sourceMappingURL=constants.js.map
